var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStatePie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1089 20.2889L13.6522 16.0356C14.85 15.1556 15.6811 13.7867 15.8522 12.2222H20.7778C20.57 15.5956 18.7611 18.5289 16.1089 20.2889ZM12.2222 4.92556V0C17.4778 0.317778 21.6822 4.52222 22 9.77778H17.0744C16.7933 7.22333 14.7767 5.20667 12.2222 4.92556ZM4.88889 11.6111C4.88889 12.3933 5.04778 13.1389 5.35333 13.8111L1.1 16.2678C0.391111 14.8622 0 13.2856 0 11.6111C0 6.07444 4.32667 1.55222 9.77778 1.22222V6.14778C7.02778 6.45333 4.88889 8.77556 4.88889 11.6111ZM10.3889 22C6.75889 22 3.56889 20.1667 1.71111 17.3311L5.96444 14.8744C6.96667 16.2311 8.55556 17.1111 10.3889 17.1111C11.1711 17.1111 11.9167 16.9522 12.5889 16.6467L15.0456 20.9C13.64 21.6089 12.0633 22 10.3889 22Z",
    fill: "#e0edf7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatePie);
export default __webpack_public_path__ + "static/media/empty-state-pie.25f1aec1275d190144af0fc0daaa7b9c.svg";
export { ForwardRef as ReactComponent };